// Add your custom JS here.

let toggleBtn = document.querySelector('.navbar-toggler');
let bodyChange = document.getElementsByTagName('body')[0];

function removeSticky() {
    header.classList.remove("sticky");
}

toggleBtn.onclick = function () {
    this.classList.toggle('active');
    bodyChange.classList.toggle('open-menu');
    if (bodyChange.classList.contains('open-menu')) {
        setTimeout(removeSticky, 500);
    } else {
        header.classList.add("sticky");
    }
};


document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
        AOS.refresh();
    }, 500);
});
// window.addEventListener('load', AOS.refresh);


window.onscroll = function () {
    fixedHeader()
};
let header = document.getElementById("wrapper-navbar");
let sticky = header.offsetTop;

function fixedHeader() {
    if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
    } else {
        header.classList.remove("sticky");
    }
}


jQuery(document).ready(function (jQuery) {


        jQuery('.widget_post_sorting select').on('change',function() {
            jQuery(this).closest('form').submit();
        });

    setTimeout(function () {
        jQuery('.custom-select').styler();
        jQuery('.styler').styler();
    }, 100);


    /////////start
    // var isoOptions = {
    //     itemSelector: '.blog-list li'
    // };
    // var $container = jQuery('.blog-content').isotope(isoOptions);
    // var $checkboxes = jQuery('.category-list input');
    // jQuery('#loadMore').on( 'click', function() {
    //     $container.isotope('destroy');
    //     $container.isotope( isoOptions );
    // });

    // $checkboxes.change( function() {
    //     $container.isotope('destroy');
    // map input values to an array
    // var inclusives = [];
    // inclusive filters from checkboxes
    // $checkboxes.each( function( i, elem ) {
    // if checkbox, use value if checked
    // if ( elem.checked ) {
    //     inclusives.push( elem.value );
    // }
    // });

    // combine inclusive filters
    // var filterValue = inclusives.length ? inclusives.join(', ') : '*';
    // $container.isotope( isoOptions );
    // $container.isotope({ filter: filterValue });
    // });
/////////////////end


    jQuery(".hero-slide").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: false,
    });

    jQuery(".work-slider").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        nextArrow: '<button type="button" class="slick-next">→</button>',
        prevArrow: '<button type="button" class="slick-prev">→</button>',
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    });

    let footMenu = document.querySelectorAll('.dropdown-toggle');
    let intFrameWidth = window.innerWidth;
    for (let i = 0; i < footMenu.length; i++) {
        if (intFrameWidth < 992) {
            footMenu[i].removeAttribute('data-toggle');
            footMenu[i].removeAttribute('data-bs-toggle');
        }
    }


///////// Work Isotope Grid
    let isoOptionsWork = {
        itemSelector: '.work-item',
        layoutMode: 'fitRows',
    };

    /*let $container_work = jQuery('.work-list').isotope(isoOptionsWork);
    let isActive = true;*/

    /*jQuery('#loadMoreWork').on('click', function () {
        if (isActive) {
            $container_work.isotope('destroy');
        } else {
            $container_work.isotope(isoOptionsWork);
        }
        isActive = !isActive;
    });
*/
   /* jQuery('.work-category').on('click', 'button', function () {
        let filterValue = jQuery(this).attr('data-filter');
        // use filterFn if matches value
        $container_work.isotope({filter: filterValue});
    });*/

    jQuery('.work-category').each(function (i, buttonGroup) {
        let $buttonGroup = jQuery(buttonGroup);
        $buttonGroup.on('click', 'button', function () {
            console.log('1');
            $buttonGroup.find('.is-checked').removeClass('is-checked');
            jQuery(this).addClass('is-checked');
            updateWorkSlider();
        });
    });

    function updateWorkSlider() {
        jQuery('.lds-ellipsis').show();
        loadmore_params.current_page = 0;
        let selectedCategory = jQuery('.work-category .is-checked').data('tax-id');
        let data = {
            'action': 'loadcategory',
            'query': loadmore_params.posts, // that's how we get params from wp_localize_script() function
            'category': selectedCategory,
        };
        jQuery.ajax({ // you can also use $.post here
            url : loadmore_params.ajaxurl, // AJAX handler
            data : data,
            type : 'POST',
            success : function( data ){
                if( data ) {
                    jQuery('.work-list').html(data);
                    loadmore_params.current_page++;
                    setTimeout(function(){
                        let currentCount = jQuery('.work-list .work-item').length;
                        let maxCount = jQuery('.work-category .is-checked').data('count');
                        jQuery('.lds-ellipsis').hide();
                        if(maxCount > currentCount){
                            jQuery('.load-more-work').show();
                        }else{
                            jQuery('.load-more-work').fadeOut();
                        }
                    },500);
                }
            }
        });
    }
    // Функция для обновления работ после фильтрации
/*** Sort ***/


function sortPosts() {
    var container = document.getElementById('postContainer');
    var posts = container.getElementsByClassName('post');

    var postsArray = Array.from(posts);

    var selectedOption = document.querySelector('select[name="ordr"] option:checked').value;

    postsArray.sort(function(a, b) {
        if (selectedOption === 'title') {
            var titleA = a.getAttribute('data-title');
            var titleB = b.getAttribute('data-title');
            return titleA.localeCompare(titleB);
        } else if (selectedOption === 'date') {
            var dateA = new Date(a.getAttribute('data-date'));
            var dateB = new Date(b.getAttribute('data-date'));
            return dateA - dateB;
        } else if (selectedOption === 'popularity') {
            var viewsA = parseInt(a.getAttribute('data-views'));
            var viewsB = parseInt(b.getAttribute('data-views'));
            return viewsB - viewsA;
        }

        return 0;
    });

    while (container.firstChild) {
        container.firstChild.remove();
    }

    postsArray.forEach(function(post) {
        container.appendChild(post);
    });
}

    document.addEventListener( 'wpcf7mailsent', function( event ) {
        var currentLanguage = custom_ajax_object.lang;

        // var redirectUrl;
        // if ( '421' == event.detail.contactFormId ) {

            if (currentLanguage == "en") {
            location = '/en/thank-you';

            } else if (currentLanguage == "nl") {
                location = "/nl/bedankt"
            } else if (currentLanguage == "de") {
                location = "/de/danke"
            }
        // }

        // location.href = redirectUrl;


    }, false );

    if (window.innerWidth <= 768) {
        var currentLanguage = custom_ajax_object.lang;

        var offerLink = document.getElementById("offer-link");
        if (offerLink) {
            if (currentLanguage == "en") {
                offerLink.textContent = "Quote";
            }
            else if (currentLanguage == "nl") {
                offerLink.textContent = "Offerte";

            }
            else if (currentLanguage == "de") {
                offerLink.textContent = "Angebot";
            }
        }
    }


    var links = document.querySelectorAll('.wp-block-column.page-single-post_anchers a');

    links.forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();

            var target = this.getAttribute('href');
            var targetElement = document.querySelector(target);

            if (targetElement) {
                var offsetTop = targetElement.getBoundingClientRect().top + window.scrollY;
                var targetOffset = offsetTop - 100;

                window.scrollTo({
                    top: targetOffset,
                    behavior: 'smooth'
                });
            }
        });
    });


});

function germany_time_shortcode() {
    var germanyTime = new Date();

    germanyTime.setTime(germanyTime.getTime() + germanyTime.getTimezoneOffset() * 60 * 1000 + 1 * 60 * 60 * 1000); // GMT+1

    var hours = germanyTime.getHours();
    var minutes = germanyTime.getMinutes();
    var seconds = germanyTime.getSeconds();

    var timeString = hours + ':' + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;

    return timeString;

}

add_shortcode('germany-time', 'germany_time_shortcode');


/// Work Isotope Grid END

jQuery(document).ready(function() {
    var postIDs = {};

    jQuery('.work-item').each(function() {
        var postID = jQuery(this).attr('id').replace('work-', ''); // Получаем ID поста
        if (postIDs[postID]) {
            jQuery(this).hide();
        } else {

            postIDs[postID] = true;
        }
    });


});
jQuery(document).ready(function() {
    jQuery(".word-break").html(function(_, html) {
        return html.replace(/<wbr>/g, '<span></span>');
    });
});

/***/

